import React from 'react';
export function RefundsPage() {
  return <div className="min-h-screen bg-[#faf8f6] py-12 md:py-20" data-id="element-683">
      <div className="max-w-4xl mx-auto px-6" data-id="element-684">
        <h1 className="text-4xl md:text-5xl font-serif text-[#2d2d2d] mb-8" data-id="element-685">
          Política de Reembolsos y Devoluciones
        </h1>

        <div className="prose prose-lg max-w-none text-[#5a5a5a] space-y-6" data-id="element-686">
          <p className="text-sm text-[#8b6f6f]" data-id="element-687">
            Última actualización:{' '}
            {new Date().toLocaleDateString('es-ES', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          })}
          </p>

          <section data-id="element-688">
            <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-689">
              Garantía de Satisfacción de 30 Días
            </h2>
            <p data-id="element-690">
              Estamos comprometidos con su satisfacción. Si no está
              completamente satisfecho con su compra de "El Divorcio Emocional",
              puede solicitar un reembolso completo dentro de los 30 días
              posteriores a la fecha de compra.
            </p>
          </section>

          <section data-id="element-691">
            <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-692">
              Condiciones para Reembolsos
            </h2>
            <p data-id="element-693">
              Para ser elegible para un reembolso, debe cumplir con las
              siguientes condiciones:
            </p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-694">
              <li data-id="element-695">
                La solicitud debe realizarse dentro de los 30 días posteriores a
                la compra
              </li>
              <li data-id="element-696">
                Debe proporcionar el número de pedido o la dirección de correo
                electrónico utilizada en la compra
              </li>
              <li data-id="element-697">
                Debe explicar brevemente el motivo de su insatisfacción
                (opcional pero apreciado para mejorar nuestros productos)
              </li>
            </ul>
          </section>

          <section data-id="element-698">
            <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-699">
              Cómo Solicitar un Reembolso
            </h2>
            <p data-id="element-700">Para solicitar un reembolso, siga estos pasos:</p>
            <ol className="list-decimal pl-6 space-y-3" data-id="element-701">
              <li data-id="element-702">
                <strong data-id="element-703">Contacte con soporte:</strong> Envíe un correo
                electrónico a nuestro equipo de soporte con el asunto "Solicitud
                de Reembolso"
              </li>
              <li data-id="element-704">
                <strong data-id="element-705">Proporcione información:</strong> Incluya su número de
                pedido, dirección de correo electrónico de compra y motivo del
                reembolso
              </li>
              <li data-id="element-706">
                <strong data-id="element-707">Confirmación:</strong> Recibirá una confirmación de
                recepción de su solicitud dentro de 24-48 horas
              </li>
              <li data-id="element-708">
                <strong data-id="element-709">Procesamiento:</strong> Su reembolso se procesará dentro
                de 5-7 días hábiles
              </li>
            </ol>
          </section>

          <section data-id="element-710">
            <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-711">
              Método de Reembolso
            </h2>
            <p data-id="element-712">
              Los reembolsos se procesarán utilizando el mismo método de pago
              que utilizó para la compra original:
            </p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-713">
              <li data-id="element-714">
                <strong data-id="element-715">Tarjeta de crédito/débito:</strong> El reembolso
                aparecerá en su estado de cuenta dentro de 5-10 días hábiles
              </li>
              <li data-id="element-716">
                <strong data-id="element-717">PayPal:</strong> El reembolso se acreditará en su cuenta
                de PayPal dentro de 3-5 días hábiles
              </li>
              <li data-id="element-718">
                <strong data-id="element-719">Otros métodos:</strong> Los tiempos pueden variar según
                el procesador de pagos
              </li>
            </ul>
          </section>

          <section data-id="element-720">
            <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-721">
              Productos Digitales
            </h2>
            <p data-id="element-722">
              Dado que "El Divorcio Emocional" es un producto digital, no hay
              devoluciones físicas. Una vez procesado el reembolso, se espera
              que elimine todas las copias del material descargado.
            </p>
          </section>

          <section data-id="element-723">
            <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-724">
              Excepciones
            </h2>
            <p data-id="element-725">No se otorgarán reembolsos en los siguientes casos:</p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-726">
              <li data-id="element-727">Solicitudes realizadas después de 30 días de la compra</li>
              <li data-id="element-728">Violación de nuestros Términos y Condiciones</li>
              <li data-id="element-729">
                Uso indebido del producto o intento de distribución no
                autorizada
              </li>
              <li data-id="element-730">Compras realizadas a través de terceros no autorizados</li>
            </ul>
          </section>

          <section data-id="element-731">
            <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-732">
              Cancelaciones
            </h2>
            <p data-id="element-733">
              Dado que el acceso al producto es inmediato tras la compra, no es
              posible cancelar un pedido una vez completado. Sin embargo, puede
              solicitar un reembolso dentro del período de garantía de 30 días.
            </p>
          </section>

          <section data-id="element-734">
            <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-735">
              Problemas Técnicos
            </h2>
            <p data-id="element-736">
              Si experimenta problemas técnicos con la descarga o acceso al
              producto:
            </p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-737">
              <li data-id="element-738">Contacte primero con nuestro equipo de soporte técnico</li>
              <li data-id="element-739">Intentaremos resolver el problema dentro de 24-48 horas</li>
              <li data-id="element-740">
                Si no podemos resolver el problema, se le ofrecerá un reembolso
                completo
              </li>
            </ul>
          </section>

          <section data-id="element-741">
            <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-742">
              Disputas
            </h2>
            <p data-id="element-743">
              Si tiene alguna disputa sobre un cargo, le recomendamos que se
              comunique con nosotros primero antes de iniciar una disputa con su
              banco o procesador de pagos. Estamos comprometidos a resolver
              cualquier problema de manera justa y rápida.
            </p>
          </section>

          <section data-id="element-744">
            <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-745">
              Cambios en esta Política
            </h2>
            <p data-id="element-746">
              Nos reservamos el derecho de modificar esta política de reembolsos
              en cualquier momento. Los cambios entrarán en vigor inmediatamente
              después de su publicación en el sitio web. Las compras realizadas
              antes de cualquier cambio estarán sujetas a la política vigente en
              el momento de la compra.
            </p>
          </section>

          <section data-id="element-747">
            <h2 className="text-2xl font-serif text-[#2d2d2d] mt-8 mb-4" data-id="element-748">
              Contacto
            </h2>
            <p data-id="element-749">
              Si tiene preguntas sobre nuestra Política de Reembolsos y
              Devoluciones, puede contactarnos a través de nuestro correo
              electrónico de soporte. Nuestro equipo está disponible para
              ayudarle y responderá a su consulta lo antes posible.
            </p>
          </section>
        </div>

        <div className="mt-12 pt-8 border-t border-[#d4a5a5]/30" data-id="element-750">
          <a href="/" className="text-[#9d4b6b] hover:text-[#8b6f6f] transition-colors font-medium" data-id="element-751">
            ← Volver a la página principal
          </a>
        </div>
      </div>
    </div>;
}